export default "__VITE_ASSET__BmEKkMYL__"